<template>
    <v-dialog max-width="800px" v-model="modal">
        <v-card>
            <v-card-title>
                <span class="text-h5">{{ 'Add new' }}</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col
                            cols="12"
                            sm="12"
                            md="12"
                        >
                            <v-text-field v-model="companyData.value"
                                          dense
                                          :loading="stationLocationsLoading"
                                          label="Company name"
                                          placeholder="Company name"
                                          hide-details
                                          type="text"/>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="handleCloseClick"
                >
                    Close
                </v-btn>
                <v-btn
                    color="blue darken-1"
                    text
                    @click="handleSaveClick"
                >
                    Save
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
    name: 'CompaniesEdit',
    data() {
        return {
            modal: true,
            routeId: null,
            stationLocationsLoading: true,
            companyData: {
                id: null,
                value: null,
                client_nrs: null,
                station_locations: [],
            },
        };
    },
    computed: {
        ...mapState('company', ['companies', 'copyOfCompanies', 'stationLocationLongAliases']),
    },
    watch: {
        companies: function(value) {
            if (this.routeId !== 'new') {
                this.companyData = value.find(company => company.id === parseInt(this.routeId));
                this.handleStationLocationsFetch(parseInt(this.routeId));
            }
        },
        modal: function(value) {
            if (!value) {
                this.handleCloseClick();
            }
        },
    },
    async mounted() {
        await this.fetchStationLocationLongAliases();
        this.routeId = this.$route.params.id;

        if (this.routeId !== 'new') {
            this.companyData = this.companies.find(company => company.id === parseInt(this.routeId));
            await this.handleStationLocationsFetch(parseInt(this.routeId));
        } else {
            this.stationLocationsLoading = false;
        }
    },
    methods: {
        ...mapActions('company', ['fetchStationLocationLongAliases', 'fetchCompanyStationLocations', 'createCompany', 'updateCompany']),
        async handleStationLocationsFetch(companyId) {
            const response = await this.fetchCompanyStationLocations(companyId);

            if (response && response.status === 200) {
                this.companyData.station_locations = response.data.station_locations.map(sl => sl.id);
            } else {
                console.error('Failed to fetch station locations:', response);
            }
            this.stationLocationsLoading = false;


        },
        handleCloseClick() {
            this.$router.push({name: 'company-list'});
        },
        handleSaveClick() {
            if (this.routeId === 'new') {
                this.createCompany(this.companyData);
            } else {
                this.updateCompany(this.companyData);
            }
            this.handleCloseClick();
        },
    },
};
</script>

<style scoped>

</style>